import React from 'react'
import {useSelector} from 'react-redux'
import {ButtonLink, Icon, THEME_COLORS} from 'ac_ui'
import {acArrowRight, acCheckCircle} from 'ac-icon'
import {IReduxState} from '../../../redux/types/IReduxState'
import {TaskListItemDto} from 'learndb-share'
import {URLS} from '../../../constants/urls'

const TaskSolvedControls: React.FC = () => {
  const themeTasks = useSelector<IReduxState, TaskListItemDto[] | undefined>((state) => state.task?.themeTasks)
  const currentTaskId = useSelector<IReduxState, number | undefined>((state) => state.task?.task?.taskId)

  let indexCurrentTask
  themeTasks.forEach((task, index) => {
    if (task.taskId === currentTaskId) {
      indexCurrentTask = index
      return
    }
  })

  const isLastTask = indexCurrentTask === themeTasks.length - 1

  const nextUrl = isLastTask ? URLS.themes : URLS.tasks + '/' + themeTasks[indexCurrentTask + 1].taskId

  return (
    <div className={'task-solved-controls'}>
      <div className={'d-flex flex-row align-items-center'}>
        <div className={'d-flex mr-x1'}>
          <Icon path={acCheckCircle} title={undefined} color={THEME_COLORS.success} />
        </div>
        <p className={'task-solved-indicator'}>Поздравляем, урок пройден!</p>
      </div>
      <ButtonLink
        size={'sm'}
        href={nextUrl}
        color={isLastTask ? 'primary' : 'success'}
        iconPath={acArrowRight}
        iconPosition={'right'}
        className={'next-button'}>
        {isLastTask ? 'К программе' : 'Следующий урок'}
      </ButtonLink>
    </div>
  )
}

export {TaskSolvedControls}
